import { connect, injectReducer, injectSaga } from '@vfde-sails/core';
import { createStructuredSelector } from 'reselect';
import { RootState } from './types';
import reducer from './reducer';
import glasfaserRegistrationSaga from './saga';
import './style.scss';
import {
    selectLoading,
    selectError,
    selectInitRegistrationForm,
    selectRegistrationData,
    selectResponseData,
} from './selector';
import { SAILS_APP_NAME } from '../../constant';
import {
    initRegistrationForm,
    readSessionStorage,
    saveRegistrationData,
    sendRegistrationData,
} from './action';
import { mountRegistrationForm } from './helpers/mountRegistrationForm';
import { FormType } from './constant';
import { mountLoadingSpinner, toggleLoadingSpinner } from '../../components/LoadingSpinner';
import { StateProps } from './interface';
import { setAddressDataFromSession } from 'Container/glasfaserRegistration/helpers/landUseFormHelper';
import { getFormType, getFormUpdateFunction, isStateChanged } from './helpers/formHelper';
import { mountLandUseForm } from './helpers/mountLandUseForm';
import { mountNotifications } from './helpers/mountNotifications';

/**
 * glasfaserRegistration function
 */
function glasfaserRegistration (state: StateProps, action) {

    injectReducer(SAILS_APP_NAME, reducer );
    injectSaga(SAILS_APP_NAME, glasfaserRegistrationSaga);

    const formType = getFormType();
    const loadingSpinner = mountLoadingSpinner();
    const updateForm = getFormUpdateFunction(formType);
    mountNotifications();

    switch (formType) {
        case FormType.REGISTRATION:
            mountRegistrationForm(action);
            action.initRegistrationForm();
            break;
        case FormType.LANDUSE:
            mountLandUseForm(action);
            action.initRegistrationForm();
            setAddressDataFromSession(action);
            break;
    }

    return {
        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState - You may also pass the oldState here, if needed
         */
        getDerivedStateFromProps (newState: StateProps, oldState: StateProps) {

            if (newState.loading !== oldState.loading) {
                toggleLoadingSpinner(loadingSpinner, newState.loading);
            }

            if (isStateChanged(newState, oldState)) {
                updateForm(newState);
            }
        },
    };
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    loading: selectLoading(),
    error: selectError(),
    initRegistrationForm: selectInitRegistrationForm(),
    registrationData: selectRegistrationData(),
    responseData: selectResponseData(),
});

const mapDispatch = {
    initRegistrationForm,
    saveRegistrationData,
    sendRegistrationData,
    readSessionStorage,
};

const GlasfaserRegistration = connect(mapStateToProps, mapDispatch)(glasfaserRegistration);
export default GlasfaserRegistration;
